import React from "react";
import FollowButton from "../Components/FollowButton.tsx";
import ShareButton from "../Components/ShareButton.tsx";

interface FooterCardProps {
  isFollowed: boolean;
  onToggleFollow: () => void;
  link: string;
  onCopy?: () => void;
}


const FooterCard: React.FC<FooterCardProps> = ({ isFollowed, onToggleFollow, link, onCopy }) => {
  return (
    <div className="">
      <div className="cursor-pointer flex gap-2">
        <FollowButton isFollowed={isFollowed} onToggleFollow={onToggleFollow} />
      
        <ShareButton link={link} onCopy={onCopy}/>
      </div>
    </div>
  );
};

export default FooterCard;